import { CommonModule } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  ModuleWithProviders,
  NgModule,
  NO_ERRORS_SCHEMA,
  Provider,
} from '@angular/core';
import { TRANSLATE_SERVICE } from '@luggagehero/shared/interfaces';
import {
  createTranslateLoader,
  createTranslateParser,
  SharedTranslateService,
} from '@luggagehero/shared/services/translation';
import { SharedWindowService } from '@luggagehero/shared/services/window';
import { TranslateLoader, TranslateModule, TranslateParser } from '@ngx-translate/core';

import { MultilingualService } from './services/index';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forRoot({
      // Per-key fallback: a key with no value in the active language resolves to its
      // English copy instead of rendering raw (ngx-translate falls back to the default
      // language map key-by-key). Costs one extra /app_text load (en) for non-English
      // sessions — accepted; the response is cached like any other language (AM-4589).
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
      },
      parser: {
        provide: TranslateParser,
        useFactory: createTranslateParser,
      },
    }),
  ],
  declarations: [],
  exports: [TranslateModule],
  providers: [
    MultilingualService,
    SharedTranslateService,
    { provide: TRANSLATE_SERVICE, useExisting: SharedTranslateService },
    SharedWindowService,
  ],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
})
export class MultilingualModule {
  // optional usage
  // ideally we could use this to override TranslateModule, but it requires the static above at moment
  static forRoot(configuredProviders: Provider[]): ModuleWithProviders<MultilingualModule> {
    return {
      ngModule: MultilingualModule,
      providers: configuredProviders,
    };
  }

  constructor() {
    const parentModule = inject(MultilingualModule, { optional: true, skipSelf: true });

    if (parentModule) {
      throw new Error('MultilingualModule already loaded; Import in root module only.');
    }
  }
}
